import { gql, useQuery } from "@apollo/client";

export interface CustomUrlForEdit {
  id: string;
  tenantId: string;
  slug: string;
  targetType: "landing_page" | "internal_path";
  targetLandingPageId: string | null;
  targetPath: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const CUSTOM_URL_FOR_EDIT = gql`
  query CustomUrl($id: String!) {
    CustomUrl(id: $id) {
      id
      tenantId
      slug
      targetType
      targetLandingPageId
      targetPath
      isActive
      createdAt
      updatedAt
    }
  }
`;

export function useCustomUrlData(id: string | undefined) {
  const result = useQuery<{ CustomUrl: CustomUrlForEdit | null }>(
    CUSTOM_URL_FOR_EDIT,
    {
      variables: { id: id ?? "" },
      skip: !id,
      fetchPolicy: "cache-and-network",
    },
  );
  return {
    url: result.data?.CustomUrl ?? null,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}
